var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, forwardRef, useImperativeHandle, useMemo, useEffect, } from "react";
import TextField, { useTextField } from "../TextField";
import { isNaN } from "lodash";
import MobileArea from "./MobileArea";
export var DEFAULT_MOBILE_RULES = [{ required: true }, { type: "mobile" }];
var MobileTextField = forwardRef(function (_a, ref) {
    var _b;
    var rules = _a.rules, options = _a.options, mobile = _a.mobile, onChange = _a.onChange, area = _a.area, onAreaChange = _a.onAreaChange, size = _a.size, sx = _a.sx, disabled = _a.disabled, areaProps = _a.areaProps, defaultMobile = _a.defaultMobile, rest = __rest(_a, ["rules", "options", "mobile", "onChange", "area", "onAreaChange", "size", "sx", "disabled", "areaProps", "defaultMobile"]);
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var handleOpenChange = function (o) {
        setOpen(o);
    };
    var memoRules = useMemo(function () {
        var _a, _b;
        if ((_a = areaProps === null || areaProps === void 0 ? void 0 : areaProps.value) === null || _a === void 0 ? void 0 : _a.key) {
            if (((_b = areaProps === null || areaProps === void 0 ? void 0 : areaProps.value) === null || _b === void 0 ? void 0 : _b.key) === "CN_243") {
                return rules || DEFAULT_MOBILE_RULES;
            }
        }
        else if ((area === null || area === void 0 ? void 0 : area.key) === "CN_243") {
            return rules || DEFAULT_MOBILE_RULES;
        }
        return (rules || [
            { required: true },
            function (s) { return (isNaN(Number(s === null || s === void 0 ? void 0 : s.value)) ? "请输入正确的手机号" : ""); },
        ]);
    }, [rules, area === null || area === void 0 ? void 0 : area.key, (_b = areaProps === null || areaProps === void 0 ? void 0 : areaProps.value) === null || _b === void 0 ? void 0 : _b.key]);
    var mobileFieldProps = useTextField(__assign(__assign({ value: mobile, label: "手机号*", onChange: onChange, size: size, disabled: disabled, rules: memoRules, InputProps: {
            placeholder: "请输入手机号",
            endAdornment: (React.createElement(MobileArea, { size: size, disabled: disabled, area: (areaProps === null || areaProps === void 0 ? void 0 : areaProps.value) || area, open: open, options: (areaProps === null || areaProps === void 0 ? void 0 : areaProps.options) || options, onChange: (areaProps === null || areaProps === void 0 ? void 0 : areaProps.onAreaChange) || onAreaChange, onOpenChange: handleOpenChange, defaultMobile: defaultMobile })),
        } }, rest), { sx: __assign(__assign(__assign({}, (sx || {})), { '& .MuiInputLabel-root[data-shrink="false"]': {
                left: size === "small" ? "75px" : "100px",
            }, '& .MuiInputLabel-root[data-shrink="true"]': {
                "&+.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline legend": {
                    minWidth: "fit-content",
                },
            }, "& .MuiInputLabel-root.Mui-focused:not(.Mui-error)": {
                "&+.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#4caf50",
                },
            }, "&>.MuiOutlinedInput-root>.MuiOutlinedInput-input": {
                paddingLeft: size === "small" ? "90px" : "112px",
            } }), (open && {
            "&>.MuiOutlinedInput-root:not(.Mui-error):hover>.MuiOutlinedInput-notchedOutline": {
                borderColor: "#4caf50",
            },
            "&>.MuiOutlinedInput-notchedOutline": {
                borderColor: "#4caf50",
                borderWidth: 1,
            },
            "& .MuiInputLabel-root": {
                color: "#4caf50",
            },
            "& .Mui-error": {
                color: "#ff6c6c",
                "&+.MuiOutlinedInput-root": {
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#ff6c6c",
                    },
                },
            },
        })) }));
    useImperativeHandle(ref, function () { return ({
        setError: mobileFieldProps.setError,
        validate: function () { return mobileFieldProps.handleValidate(); },
        error: mobileFieldProps.error,
    }); });
    useEffect(function () {
        var _a;
        if (mobile) {
            (_a = mobileFieldProps === null || mobileFieldProps === void 0 ? void 0 : mobileFieldProps.handleValidate) === null || _a === void 0 ? void 0 : _a.call(mobileFieldProps);
        }
    }, []);
    return React.createElement(TextField, __assign({ id: "mobile-text" }, mobileFieldProps));
});
export default MobileTextField;
